module.exports = __webpack_public_path__ + "img/051-sprinkle-1.82511236.svg";